import React from 'react'
import { RemotePopupUi } from './remote-popup-ui'
import { useCalculateTypography } from 'src/editor/shared/hooks/use-calculate-typography'

interface RemotePopupProps {
  children?: React.ReactNode
}

export const RemotePopup = ({ children }: RemotePopupProps) => {
  const {
    calculatedFontSize,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateTypography()

  return (
    <RemotePopupUi
      fontFamily={calculatedFontFamily.desktop}
      fontSize={calculatedFontSize.desktop}
      mobileFontSize={calculatedFontSize.mobile}
    >
      {children}
    </RemotePopupUi>
  )
}
